module.exports = __webpack_public_path__ + "assets/7312891eeac94c8dd1ea4ab94f7ba181.png";